import { render } from "./TableCard.vue?vue&type=template&id=30c1cb5d&scoped=true"
import script from "./TableCard.vue?vue&type=script&lang=js"
export * from "./TableCard.vue?vue&type=script&lang=js"

import "./TableCard.vue?vue&type=style&index=0&id=30c1cb5d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c1cb5d"]])

export default __exports__